import { makeStyles } from '@material-ui/core'

const useStyles = makeStyles((theme) => ({
  root: {
    paddingTop: theme.spacing(4),
    paddingBottom: theme.spacing(6),
  },
  backRow: {
    display: 'flex',
    alignItems: 'center',
    gap: theme.spacing(0.5),
    marginBottom: theme.spacing(3),
    cursor: 'pointer',
    width: 'fit-content',
    '&:hover $backLabel': {
      textDecoration: 'underline',
    },
  },
  backButton: {
    color: theme.palette.text.primary,
    padding: theme.spacing(0.5),
  },
  backLabel: {
    fontSize: 14,
    fontWeight: 500,
    color: theme.palette.text.primary,
  },
  header: {
    marginBottom: theme.spacing(4),
  },
  title: {
    fontSize: 40,
    fontWeight: 700,
    color: theme.palette.text.primary,
    marginBottom: theme.spacing(1.5),
    lineHeight: 1.1,
  },
  description: {
    fontSize: 14,
    color: theme.palette.text.secondary,
    lineHeight: 1.7,
    maxWidth: 860,
  },
  controls: {
    display: 'flex',
    alignItems: 'center',
    gap: theme.spacing(2),
    marginBottom: theme.spacing(4),
    '@media (max-width: 600px)': {
      flexDirection: 'column',
      alignItems: 'stretch',
    },
  },
  searchField: {
    flex: 1,
    backgroundColor: theme.palette.background.paper,
    borderRadius: 8,
  },
  orderSelect: {
    minWidth: 160,
    backgroundColor: theme.palette.background.paper,
    height: 40,
    '& .MuiOutlinedInput-input': {
      paddingTop: theme.spacing(1.25),
      paddingBottom: theme.spacing(1.25),
      fontSize: 14,
    },
  },
  grid: {
    display: 'grid',
    gridTemplateColumns: 'repeat(auto-fill, minmax(260px, 1fr))',
    gap: theme.spacing(3),
  },
  emptyBox: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    minHeight: 240,
  },
  emptyText: {
    fontSize: 15,
    color: theme.palette.text.secondary,
  },
  pagination: {
    marginTop: theme.spacing(4),
    borderTop: `1px solid ${theme.palette.divider}`,
  },
}))

export default useStyles
